<template>
  <div class="container">

    <div v-if="view" class="columns" style="align-items:center;">
      <div class="column col-5 col-md-12">
        <h1>{{view.title}}</h1>
      </div>
      <div class="column col-1 col-md-2">
        <button v-if="chosenDay" @click="openNewEventModal" class="btn btn-sm" :class="{loading:loadingEvents}">
          New
        </button>
      </div>
      <div class="column col-3 col-md-5">
        <div class="btn-group btn-group-block">
          <button @click="changeView" class="btn btn-sm" :class="{active:monthView}">Month</button>
          <button @click="changeView" class="btn btn-sm" :class="{active:!monthView}">Week</button>
        </div>
      </div>
      <div class="column col-3 col-md-5">
        <div class="btn-group btn-group-block">
          <button @click="today" class="btn btn-sm">Today</button>
          <button @click="prev" class="btn btn-sm"><i class="fa fa-chevron-left"></i></button>
          <button @click="next" class="btn btn-sm"><i class="fa fa-chevron-right"></i></button>
        </div>
      </div>
    </div>

    <div id="calendar"></div>

    <!-- NEW EVENT MODAL -->
    <div class="modal" :class="{active: showNewEventModal}">
      <div class="modal-container">
        <div class="modal-header">
          <a @click="showNewEventModal = false" class="btn btn-clear float-right" aria-label="Close"></a>
          <div class="modal-title h5">New event</div>
        </div>
        <div class="modal-body">
          <div class="content">
            <form v-if="chosenDay" class="form-horizontal">

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Date</label>
                </div>
                <!-- <div class="col-9">{{chosenDay.format('DD/MM/YYYY')}}</div> -->
                <div class="col-9">{{calendar.formatDate(chosenDay, 'DD/MM/YYYY')}}</div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Title</label>
                </div>
                <div class="col-9">
                  <input class="form-input" type="text" v-model="newEvent.title"/>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">All day</label>
                </div>
                <div class="col-9">
                  <label class="form-checkbox">
                    <input type="checkbox" v-model="newEvent.allDay">
                    <i class="form-icon"></i>
                  </label>
                </div>
              </div>

              <div v-if="!newEvent.allDay" class="form-group">
                <div class="col-3">
                  <label class="form-label">Start</label>
                </div>
                <div class="col-9">
                  <select class="form-select picktime" v-model.number="newEvent.startHour">
                    <option v-for="(v, k) in hours" :value="k">{{v}}</option>
                  </select>
                  <span><b>:</b></span>
                  <select class="form-select picktime" v-model.number="newEvent.startMin">
                    <option v-for="(v, k) in minutes" :value="k">{{v}}</option>
                  </select>
                </div>
              </div>

              <div v-if="!newEvent.allDay" class="form-group">
                <div class="col-3">
                  <label class="form-label">End</label>
                </div>
                <div class="col-9">
                  <select class="form-select picktime" v-model.number="newEvent.endHour">
                    <option v-for="(v, k) in hours" :value="k">{{v}}</option>
                  </select>
                  <span><b>:</b></span>
                  <select class="form-select picktime" v-model.number="newEvent.endMin">
                    <option v-for="(v, k) in minutes" :value="k">{{v}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Details</label>
                </div>
                <div class="col-9">
                  <textarea class="form-input" rows="3" v-model="newEvent.details"></textarea>
                </div>
              </div>
            </form>

          </div>
        </div>
        <div class="modal-footer">
          <button @click="makeEvent" class="btn" :class="{loading: saving}">Save</button>
        </div>
      </div>
    </div>
    <!-- END NEW EVENT MODAL -->

    <!-- VIEW EVENT MODAL -->
    <div class="modal" :class="{active: showEventModal}">
      <div v-if="chosenEvent" class="modal-container">
        <div class="modal-header">
          <a @click="showEventModal = false" class="btn btn-clear float-right" aria-label="Close"></a>
          <div class="modal-title h5">{{chosenEvent.title}}</div>
        </div>
        <div class="modal-body">
          <div class="content">

            <form class="form-horizontal">
              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Date</label>
                </div>
                <!-- <div class="col-9">{{chosenEvent.start.format('DD/MM/YYYY')}}</div> -->
                <div class="col-9">{{calendar.formatDate(chosenEvent.start, 'DD/MM/YYYY')}}</div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Title</label>
                </div>
                <div class="col-9">
                  <input class="form-input" type="text" v-model="chosenEvent.title"/>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">All day</label>
                </div>
                <div class="col-9">
                  <label class="form-checkbox">
                    <input type="checkbox" v-model="chosenEvent.allDay">
                    <i class="form-icon"></i>
                  </label>
                </div>
              </div>

              <div v-if="!chosenEvent.allDay" class="form-group">
                <div class="col-3">
                  <label class="form-label">Start</label>
                </div>
                <div class="col-9">
                  <select class="form-select picktime" v-model.number="chosenEvent.startHour">
                    <option v-for="(v, k) in hours" :value="k">{{v}}</option>
                  </select>
                  <span><b>:</b></span>
                  <select class="form-select picktime" v-model.number="chosenEvent.startMin">
                    <option v-for="(v, k) in minutes" :value="k">{{v}}</option>
                  </select>
                </div>
              </div>

              <div v-if="!chosenEvent.allDay" class="form-group">
                <div class="col-3">
                  <label class="form-label">End</label>
                </div>
                <div class="col-9">
                  <select class="form-select picktime" v-model.number="chosenEvent.endHour">
                    <option v-for="(v, k) in hours" :value="k">{{v}}</option>
                  </select>
                  <span><b>:</b></span>
                  <select class="form-select picktime" v-model.number="chosenEvent.endMin">
                    <option v-for="(v, k) in minutes" :value="k">{{v}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Details</label>
                </div>
                <div class="col-9">
                  <textarea class="form-input" rows="3" v-model="chosenEvent.details"></textarea>
                </div>
              </div>
            </form>

          </div>
        </div>
        <div class="modal-footer">
          <button @click="updateEvent" class="btn" :class="{loading: saving}">Save</button>
          <button @click="deleteEvent" class="btn">Delete</button>
        </div>
      </div>
    </div>
    <!-- END VIEW EVENT MODAL -->

    <!-- EVENT DETAILS TOOLTIP -->
    <div class="toast" id="hoverDetails" :class="{'d-none':!hovering, 'd-block':hovering}">
      <h6>{{hoverTitle}}</h6>
      {{hoverDetails}}
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import momentPlugin from '@fullcalendar/moment'
import utils from '@/components/utils'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
// import '@fullcalendar/timegrid/main.css'
import '@fullcalendar/list/main.css'

export default {
  name: 'calendar',
  mixins: ['utils'],
  data () {
    return {
      calendar: null,
      // events: [], // possibly not needed
      view: null, // calendar view object
      showEventModal: false,
      showNewEventModal: false,
      chosenDay: null,
      chosenEvent: null,
      dblClickWaiting: false, // still within the double click period?
      saving: false,
      loadingEvents: true,
      newEvent: null,
      monthView: true,
      // hoverEvent: null,
      hovering: false,
      hoverTitle: '',
      hoverDetails: '',
      tempEvent: {
        id: '',
        title: '',
        allDay: true,
        startHour: 0,
        startMin: 0,
        endHour: 0,
        endMin: 0,
        extendedProps: {
          details: ''
        }
      },
      hours: {
        0: '00',
        1: '01',
        2: '02',
        3: '03',
        4: '04',
        5: '05',
        6: '06',
        7: '07',
        8: '08',
        9: '09',
        10: '10',
        11: '11',
        12: '12',
        13: '13',
        14: '14',
        15: '15',
        16: '16',
        17: '17',
        18: '18',
        19: '19',
        20: '20',
        21: '21',
        22: '22',
        23: '23'
      },
      minutes: {
        0: '00',
        5: '05',
        10: '10',
        15: '15',
        20: '20',
        25: '25',
        30: '30',
        35: '35',
        40: '40',
        45: '45',
        50: '50',
        55: '55'
      }
    }
  },
  created () {
    this.resetNewEvent()
    axios.get('/api/events/user').then(res => {
      if (res.status === 200) {
        this.loadingEvents = false
        if (res.data && this.calendar) {
          this.calendar.batchRendering(() => {
            for (var e of res.data) {
              this.calendar.addEvent({
                id: e._id,
                allDay: e.allDay,
                start: new Date(e.start),
                end: new Date(e.end),
                title: e.title,
                extendedProps: {
                  user: e.user,
                  matter: e.matter,
                  details: e.details,
                  hasOwner: e.hasOwner
                }
              })
            }
          })
          // this.events = this.calendar.getEvents()
        }
      }
    })
  },
  mounted () {
    let el = document.getElementById('calendar')
    // let cal = new FullCalendar.Calendar(el, {
    let cal = new Calendar(el, {
      plugins: [ dayGridPlugin, listPlugin, momentPlugin ],
      selectable: true,
      editable: true,
      header: false,
      timezone: 'UTC',
      // events: this.events,
      eventBackgroundColor: '#D04881',
      eventBorderColor: '#D04881',
      eventColor: 'blue',
      aspectRatio: screen.width < 600 ? 1.02 : 1.2,
      dayClick: (d) => { this.dayClick(d) },
      eventClick: (e) => { this.eventClick(e) },
      eventDrop: (e) => { this.eventDrop(e) },
      eventMouseover: (e, jsEvent) => { this.eventMouseover(e, jsEvent) },
      eventMouseout: () => { this.eventMouseout() }
    })
    cal.render()
    this.calendar = cal
    // this.view = cal.getView()
    this.view = cal.view
    this.chosenDay = cal.getDate()
  },
  methods: {
    today () {
      this.calendar.today()
      this.chosenDay = this.calendar.getDate()
    },
    prev () {
      this.calendar.prev()
    },
    next () {
      this.calendar.next()
    },
    changeView () {
      this.monthView = !this.monthView
      if (this.monthView) {
        this.calendar.changeView('dayGridMonth')
      } else {
        this.calendar.changeView('listWeek')
      }
    },
    // Double click a day to open the new event modal
    dayClick (date) {
      if (this.dblClickWaiting && this.chosenDay._i === date._i) {
        this.openNewEventModal()
      } else {
        this.chosenDay = date
        this.dblClickWaiting = true
        utils.methods.delay(500, () => { this.dblClickWaiting = false })
      }
    },
    eventClick (e) {
      // Setup the fields for capturing start/end times
      this.chosenEvent = e.event
      this.tempEvent = {
        id: e.event.id,
        title: e.event.title,
        allDay: e.event.allDay,
        startHour: e.event.start.getHours(),
        startMin: e.event.start.getMinutes(),
        extendedProps: {
          details: e.event.extendedProps.details
        }
      }
      if (!e.event.end) {
        this.tempEvent.endHour = 23
        this.tempEvent.endMin = 59
      } else {
        this.tempEvent.endHour = e.event.end.getHours()
        this.tempEvent.endMin = e.event.end.getMinutes()
      }
      this.showEventModal = true
    },
    eventDrop (e) {
      this.saveEvent(e)
    },
    eventMouseover (e, jsEvent) {
      if (!e.details || !this.monthView) return
      let el = document.getElementById('hoverDetails')
      el.style.left = jsEvent.clientX + 'px'
      el.style.top = jsEvent.clientY + 20 + 'px'
      this.hoverTitle = e.title
      this.hoverDetails = e.details
      this.hovering = true
    },
    eventMouseout () {
      this.hovering = false
    },
    openNewEventModal () {
      this.saving = false
      this.showNewEventModal = true
    },
    makeEvent () {
      // reference
      this.newEvent = {
        user: null,
        start: null,
        startHour: 0,   // only used for capture
        startMin: 0,    // only used for capture
        end: null,
        endHour: 0,     // only used for capture
        endMin: 0,      // only used for capture
        title: '',
        details: '',
        allDay: true,
        hasOwner: false // For now, events are for all admins
      }

      // The event to be added to the calendar
      let e = {
        allDay: this.newEvent.allDay,
        start: new Date(this.chosenDay),
        end: new Date(this.chosenDay),
        title: this.newEvent.title,
        extendedProps: {
          user: this.newEvent.user,
          matter: this.newEvent.matter,
          details: this.newEvent.details,
          hasOwner: this.newEvent.hasOwner
        }
      }

      e.user = this.$root.$data.user._id

      if (e.allDay) {
        e.start = this.chosenDay
      } else {
        this.chosenDay.hour(e.startHour)
        this.chosenDay.minute(e.startMin)
        e.start = this.chosenDay
        this.chosenDay.hour(e.endHour)
        this.chosenDay.minute(e.endMin)
        e.end = this.chosenDay
      }

      this.saving = true
      axios.post('/api/events/new', e)
      .then(res => {
        if (res.status === 200) {
          this.saving = false
          e._id = res.data // store the new ObjectId
          // this.events.push(this.newEvent)
          // this.calendar.renderEvent(e, true)
          this.calendar.addEvent(e)
          this.resetNewEvent()
          this.showNewEventModal = false
        }
      })
      .catch(err => {
        this.saving = false
        console.log(err)
      })
    },
    updateEvent () {
      let e = this.chosenEvent
      let t = this.tempEvent
      if (t.allDay) {
        e.setAllDay(true)
      } else {
        e.setAllDay(false)
        let start = new Date(e.start)
        let end = new Date(e.end)
        start.setHours(t.startHour)
        start.setMinutes(e.startMin)
        end.setHours(t.endHour)
        end.setMinutes(e.endMin)
        e.setStart(start)
        e.setEnd(end)
      }
      // this.saveEvent(e)
    },
    saveEvent (e) {
      this.saving = true
      //
      // HERE
      //
      let data = {
        _id: e.id,
        user: e.user,
        matter: e.matter,
        start: e.start,
        end: e.end,
        allDay: e.allDay,
        title: e.title,
        details: e.details
      }
      axios.post('/api/events/update', data)
      .then(res => {
        if (res.status === 200) {
          this.calendar.removeEvents(e._id)
          this.calendar.renderEvent(data, true)
          this.saving = false
          this.showEventModal = false
        }
      })
      .catch(err => {
        this.saving = false
        console.log(err)
      })
    },
    deleteEvent () {
      this.saving = true
      let e = this.chosenEvent
      axios.post('/api/events/delete/' + e._id)
      .then(res => {
        if (res.status === 200) {
          this.calendar.removeEvents(e._id)
          this.saving = false
          this.showEventModal = false
        }
      })
      .catch(err => {
        this.saving = false
        console.log(err)
      })
    },
    // Set up an object to capture the new event form
    resetNewEvent () {
      this.newEvent = {
        user: null,
        start: null,
        startHour: 0,   // only used for capture
        startMin: 0,    // only used for capture
        end: null,
        endHour: 0,     // only used for capture
        endMin: 0,      // only used for capture
        title: '',
        details: '',
        allDay: true,
        hasOwner: false // For now, events are for all admins
      }
    }
  }
}
</script>

<style scoped>
.picktime {
  width: 60px !important;
}
#hoverDetails {
  position: absolute;
  z-index:1000;
  width: auto;
}
.btn.active, .btn:active {
 background: #136efb;
  border-color: #136efb;
}
.btn {
  border-color: #136efb;
  color: #136efb;
}
.btn:focus, .btn:hover {
  border-color: #136efb;
  color: #136efb;
}
.btn:focus, .btn:hover {
  background: #dceafe!important
}
@media (max-width: 600px) {
  #calendar {
    margin: 1em 0;
  }
}
</style>



// WEBPACK FOOTER //
// calendar.vue?3906b468